module.exports = __webpack_public_path__ + "static/Janowo_Park_III_ujecie_02-7b7c3b981de60634b4a0b6c9a0353e4e.jpg";